import { Component, Provide, Vue, Watch } from 'vue-property-decorator';

import MessageModel from '../../components/messageModel';
import store from '../../store';
import Navbar from './components/navbar';
import ShipmentView from './components/shipment-view';
import Sidebar from './components/sidebar';
import template from './tmpl.vue';

@Component({
    components: {
        Navbar,
        ShipmentView,
        Sidebar,
        MessageModel,
    },
    mixins: [template],
    store,
})
class C extends Vue {
    isFold: boolean = false;
    isRouterAlive: boolean = true;

    get messageModel() {
        return this.$store.getters.messageModel;
    }

    @Provide('reload')
    reload() {
        this.isRouterAlive = false;
        this.$nextTick(() => {
            this.isRouterAlive = true;
        });
    }

    onSidebar(isFold: boolean) {
        this.isFold = isFold;
    }

    @Watch('messageModel.isShowMessageModel', { deep: true, immediate: true })
    onMessageModelChange(val: any, oldVal: any, event: any) {
        if (val && val !== oldVal) {
            this.showMessageModal();
        }
    }

    showMessageModal() {
        this.$modal.show(this.messageModel.messageName);
    }

    closeMessageModel() {
        this.messageModel.isShowMessageModel = false;
        this.messageModel.messageModelTitle = '';
        this.messageModel.messageModelMessage = '';
        this.messageModel.backToHome = false;
        this.$store.dispatch('updateMessageModel', this.messageModel);
    }
}

export default C;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers-shipment-view/index.ts